
<section class=" h-100">
  <!-- <div class="header">
    <nav class="navbar navbar-light topbar fixed-top shadow-sm">
      <div class="container p-0">
        <a class="navbar-brand" href="#">
          <img    src="{{platform_logo}}" alt="{{platform_name}}" width="160" routerLink="/" />
        </a>
        <div class="d-flex justify-align-center float-right">
          <button routerLink="/login" class="btn btn-info btn-sm mr-2" type="button">
            Join Now / Sign In
          </button>
        </div>
      </div>
    </nav>
  </div> -->
  <app-outer-header-navigation></app-outer-header-navigation>

  <div class="page-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12 col-sm-12">
          <div class="card">
            <div class="card-body p-2">
              <div class="w-100 bg-white px-2">
                <h1 class="card-title mb-0 d-flex align-items-center">
                  <span class="lstick"></span>
                  <a href="javascript:void(0);" routerLink="/blog"><span class="mdi mdi-arrow-left mdi-24px pos-rel-1"></span></a>
                  <span>All Articles</span>
                </h1>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="blogDetailsLoader">
            <div class="card-body text-center">
              <h5 class="mt-0 d-flex align-items-start w-75">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-25">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-50">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-50">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <div class="animated-background first-loader-ad" style="height: 180px;">
                <div class="background-masker btn-divide-left"></div>
              </div>
              <h5 class="mt-0 d-flex align-items-start my-4">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-75">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start my-4">
                <span class="flex-fill animated-background-name first-loader-name-news ml-0 mr-4">
                  <div class="background-masker btn-divide-left"></div>
                </span>
                <span class="shared-dom">
                  <div class="sub-rect-news pure-background"></div>
                </span>
              </h5>
              
            </div>
            
          </div>
          <div class="card" *ngIf="emptyBlogDetails">
            <div class="card-body ">
              <h4 class="m-2 text-center">No blog available here!</h4>
            </div>
          </div>
          <div>
            <div class="card blogHeading" *ngIf="!blogDetailsLoader && !emptyBlogDetails">
              <div class="card-body">
                <div class="w-100">
                  <div class="card blogHeading">
                    <h1 class="card-title mb-0">{{blogDetailsArr.blog_title}}</h1>
                  </div>
                  <h2 class="mb-1 fs-18 text-info">
                    <span class="blog-cat">Category</span> - <span class="blog-cat-name" (click)="filterByCategory(blogDetailsArr.category_id,blogDetailsArr.category_name)">{{blogDetailsArr.category_name}}</span>
                  </h2>
                  <p class="mb-2 font-bold d-inline-block">
                    Posted on {{blogDetailsArr.posted_time}} By
                    <a href="javascript:void(0);">{{blogDetailsArr.name}}</a>
                  </p>
                  <div class="float-right">
                    <!-- <a href="javascript:void(0);" (click)="openModal(loginalert)" placement="top" ngbTooltip="Share" class="share_hover">
                  
                      <img   src="{{share_icon}}" class="img-fluid" alt="..." width="35" >
                    </a> -->

                    <div class="btn-group" dropdown [dropup]="isDropup">
                      <a href="javascript:void(0);" id="button-dropup" dropdownToggle class="share_hover dropdown-toggle" aria-controls="dropdown-basic" placement="top" ngbTooltip="Share">
                          <img alt="loading..."    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                      </a>
                      <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-dropup">
                          <li class="light-blue" role="menuitem">
                              <div (click)="postUrlCopy();">
                                  <a class="dropdown-item" href="javascript:void(0);">Copy Link To Blog</a>
                                  <a href="javascript:void(0);"><small class="d-block text-left mb-2">Click
                                          here to copy blog link</small></a>
                              </div>
                          </li>
                      </ul>
                    </div>
                  </div>
                  <div class="post-thumb mb-2">
                    <div *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media.length>0">
                      <span *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media[0].media_mime_type.includes('image/')">
                        <img   src="{{blogDetailsArr.blog_media[0].media_path}}" class="img-fluid" alt="Blog" />
                      </span>
                    </div>
                  </div>
                  <div class="post-thumb mb-2">
                    <div *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media.length>0">
                      <span *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media[0].media_mime_type.includes('video/')">
                        <video *ngIf="blogDetailsArr.blog_media[0].thumb_media_path && blogDetailsArr.blog_media[0].thumb_media_path !=''" poster="{{blogDetailsArr.blog_media[0].thumb_media_path}}" [muted]="true" src="{{blogDetailsArr.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">
                          <track label="English" kind="captions" srclang="en" src="" default>
                        </video>
                        <video *ngIf="blogDetailsArr.blog_media[0].thumb_media_path =='' || blogDetailsArr.blog_media[0].thumb_media_path==null" [muted]="true" src="{{blogDetailsArr.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">
                          <track label="English" kind="captions" srclang="en" src="" default>
                        </video>
                      </span>
                    </div>
                  </div>
              
                  <div [innerHTML]='blogDetailsArr.blog_content'></div>
                  <hr>
                  <div class="float-right">
                    <div class="btn-group" dropdown [dropup]="isDropup">
                      <a href="javascript:void(0);" id="button-dropup" dropdownToggle class="share_hover dropdown-toggle" aria-controls="dropdown-basic" placement="top" ngbTooltip="Share">
                          <img alt="loading..."    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                      </a>
                      <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu dropdown-menu-second" role="menu" aria-labelledby="button-dropup">
                          <li class="light-blue" role="menuitem">
                              <div (click)="postUrlCopy();">
                                  <a class="dropdown-item" href="javascript:void(0);">Copy Link To Blog</a>
                                  <a href="javascript:void(0);"><small class="d-block text-left mb-2">Click
                                          here to copy blog link</small></a>
                              </div>
                          </li>
                      </ul>
                    </div>
                    <!-- <a href="javascript:void(0);" (click)="openModal(loginalert)" placement="top" ngbTooltip="Share" class="share_hover">
                      <img   src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                    </a> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header bg-dark-blue rounded-top fs-14">
              Most Popular Articles
            </div>
            <div class="card-body">
            
              <div class="comment-widgets mb-0" *ngIf="!mostViewedBlogLoader">
                <ul class="list-unstyled seperater mb-0">
                  <li class="text-info cursor-pointer" *ngFor="let blogdetails of mostViewedBlogArr" (click)="goToBlog(blogdetails.blog_title_url);">
                    <a class="text-dark" href="{{blogdetails.blog_link}}">{{blogdetails.blog_title}}</a>
                  </li>
                </ul>
              </div>
              <div class="comment-widgets mb-0" *ngIf="mostViewedBlogLoader">
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
              </div>
            </div>
          </div>
          <div class="sticky">
            <div class="card">
              <div class="card-header bg-dark-blue rounded-top fs-14">
                Categories
              </div>
              <div class="card-body">
                <ul class="list-unstyled seperater mb-0" *ngIf="!categoryLoader">
                  <li class="text-info" *ngFor="let category of categoryList">
                    <a href="javascript:void(0);" (click)="filterByCategory(category.id)">
                      <!-- <div class="d-flex py-1"> -->
                      <div class="py-1">
                        {{category.category_name}}
                        <strong *ngIf="category.category_count > 0" class='ml-1'>({{category.category_count}})</strong>
                      </div>
                    </a>
                  </li>
                </ul>
                <div *ngIf="categoryLoader">
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</section>
<footer>
  <div class="container p-0">
    <div class="row">
      <div class="col-md-12">
        <ul class="list-unstyled mb-0 d-flex">
          <li class="ml-2"><a href="javascript:void(0);" routerLink="/blog" class="p-2">Blog</a></li>
     
          <li class="ml-2"><a target="_blank" href="{{help_center}}" class="p-2" rel="noopener" >Help Center</a></li>
          <li class="ml-2"><a href="javascript:void(0);" routerLink="/about" class="p-2">About us</a></li>
          <li class="ml-2"><a target="_blank" href="{{terms_condition}}" class="p-2" rel="noopener" >Terms & Conditions</a></li>
          <li class="ml-2"><a target="_blank" href="{{privacy_policy}}" class="p-2" rel="noopener" >Privacy Policy</a></li>
          <li class="ml-2"><a target="_blank" href="{{site_map}}" class="p-2" rel="noopener" >Sitemap</a></li>
          <li class="ml-2"><a target="_blank" href="{{news_site_map}}" class="p-2" rel="noopener" >News Sitemap</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
<ng-template #loginalert>
  <div class="modal-header border-0">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <img   alt="Smile" class="img-fluid mb-2" src="assets/images/smile.png" width="45" />
    <p>Please create account or login to use this features.</p>
    <a class="btn btn-info btn-sm mr-2" href="javascript:void(0);" (click)="redirectToLogin()">Login</a>
    <a href="javascript:void(0);" (click)="redirectToLogin()" class="btn btn-success btn-sm">Sign
      Up</a>
  </div>
</ng-template>